import { theme as UdsTheme } from '@updater/ui-uds';
import type { MicrositeConfigType } from 'types';

function buildConfigError(
  qualKey: string | undefined,
  remoteEligible: boolean,
  remoteConfigError: string | undefined
): string {
  if (remoteEligible && remoteConfigError) {
    return qualKey
      ? `ERR_CONFIG_${qualKey}: ${remoteConfigError}`
      : `ERR_CONFIG: ${remoteConfigError}`;
  }
  return qualKey ? `NO_CONFIG_${qualKey}` : 'NO_CONFIG_KEY';
}

export function resolveConfigState({
  remoteEligible,
  remoteLoading,
  remoteConfig,
  remoteConfigError,
  source,
  micrositeConfig,
  configKey,
  qualKey,
}: {
  remoteEligible: boolean;
  remoteLoading: boolean;
  remoteConfig: MicrositeConfigType | undefined;
  remoteConfigError: string | undefined;
  source: string | undefined;
  micrositeConfig: MicrositeConfigType | undefined;
  configKey: string | undefined;
  qualKey: string | undefined;
}) {
  if (remoteEligible && remoteLoading) {
    return { error: undefined, theme: UdsTheme };
  }
  if (!remoteConfig && !source) {
    return {
      error: buildConfigError(qualKey, remoteEligible, remoteConfigError),
      theme: UdsTheme,
    };
  }
  if (!micrositeConfig) {
    console.log(`Missing microsite config (key=${configKey})`);
    return { error: `NO_CONFIG_${configKey}`, theme: UdsTheme };
  }
  console.log(
    `[ProviderApp] loading ${configKey}${
      remoteConfig ? ' (remote)' : ` via '${source}'`
    }`
  );
  return { error: undefined, theme: micrositeConfig.defaultTheme };
}
